import styled, { css } from "styled-components"
import {
  Youtube,
  InstagramAlt,
  FacebookCircle,
  Soundcloud,
  Vimeo,
} from "@styled-icons/boxicons-logos"
import { Download } from "@styled-icons/bootstrap"

import { below, Wrapper } from "../styles"
import { Body, Markdown } from "./typography"

// Footer
// --------------------------------
export const Footer = styled.footer`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
`

export const FooterText = styled(Body)`
  margin: 35px auto 20px;
  text-align: center;
  font-size: 0.8em;
  opacity: 0.8;
`

// Contact Page
// --------------------------------
export const NameWrapper = styled(Wrapper)`
  margin: 20px auto 20px;
  text-align: center;
  font-size: 0.8em;
  opacity: 0.8;
  width: auto;

  & label {
    color: ${p => p.theme.grayScaleColor} !important;
  }
  & input,
  textarea {
    color: #fff !important;
    z-index: 1;
    &:focus {
      border-color: ${p => p.theme.accentColor} !important;
    }
  }
  & div {
    &:focus {
      border-color: ${p => p.theme.accentColor} !important;
    }
  }
  & fieldset {
    border-color: ${p => p.theme.secondaryColor};
    background: ${p => p.theme.secondaryColor};
    border-radius: 5px;
    &:focus {
      border-color: ${p => p.theme.accentColor} !important;
    }
  }
`

export const ContactSuccess = styled(Wrapper)`
  background: rgba(88, 143, 230, 0.5);
  border-radius: 5px;
  padding: 8px;
  color: ${p => p.theme.grayScaleColor};
  font-size: 1.2em;
  text-align: center;
`

const logoStyles = css`
  color: #fff;
  cursor: pointer;
  height: 45px;
  margin: 60px 20px;
  ${below.md`
    height: 35px;
    margin: 60px 10px;
  `};

  &:hover {
    color: ${p => p.theme.accentColor};
    transition: all 0.3s;
  }
`

export const LogoYoutube = styled(Youtube)`
  ${logoStyles}
`
export const LogoInstagram = styled(InstagramAlt)`
  ${logoStyles}
`
export const LogoFacebook = styled(FacebookCircle)`
  ${logoStyles}
`
export const LogoSoundcloud = styled(Soundcloud)`
  ${logoStyles}
`
export const LogoVimeo = styled(Vimeo)`
  ${logoStyles}
`

// Button
// ----------------------------------
export const Button = styled.button`
  -webkit-appearance: unset !important;
  border-radius: 0.25rem;
  background: ${props => props.theme.accentColor};
  color: white;
  border: none;
  display: inline-block;
  padding: 0.8rem 1.7rem;
  transition-duration: 0.25s;

  &:hover {
    transform: translateY(-3px);
  }
`

// Landing Page
// -----------------------------------
export const LandingImgWrapper = styled(Wrapper)`
  margin: 10px;
  width: 50%;
  ${below.md`
    margin: 40px auto 5px;
    width: 90%;
  `};
`

export const LandingText = styled(Markdown)`
  width: 50%;
  padding: 20px;
  ${below.md`
    padding: 5px;
    width: 90%;
  `};
`

export const LandingWrapper = styled(Wrapper)`
  min-height: 80vh;
  ${below.md`
    flex-direction: column;
  `};
`

// About Page
// -----------------------------------
export const AboutNav = styled(Body)`
  background: ${props => props.theme.secondaryColor};
  border-radius: 5px;
  cursor: pointer;
  padding: 5px 10px;
  color: #fff;
  margin: 8px 0;
  ${below.md`
    font-size: 0.8em
    margin: 3px 0;
  `};
`

export const AboutBox = styled(Wrapper)`
  background: ${props => props.theme.secondaryColor};
  border-radius: 5px;
  cursor: pointer;
  padding: 0px 40px 30px;
  margin: 10px 10px 30px;
  box-sizing: border-box;
  width: auto;

  & h2 {
    margin-bottom: 10px;
    padding: 0px 0px 30px;
  }
`

export const AboutBar = styled(Wrapper)`
  position: sticky;
  top: 110px;
  z-index: 1;
  background: ${p => p.theme.primaryColor};
  ${below.md`
    top: 0px;
    position: relative;
  `};
`

// Texts Page
// -----------------------------------
export const TextsBox = styled(Wrapper)`
  border: 1px solid #222;
  background: #555;
  border-radius: 5px;
  cursor: pointer;
  padding: 30px;
  margin: 10px;
`

export const LogoDownload = styled(Download)`
  color: #fff;
  cursor: pointer;
  height: 30px;
  margin: 30px 10px;

  &:hover {
    color: ${p => p.theme.accentColor};
    transition: all 0.3s;
  }
`

// News Page
// -----------------------------------
export const NewsWrapper = styled(Wrapper)`
  margin: 40px 0;
  width: auto;
  ${below.md`
    flex-direction: column;
  `};
`

export const NewsImg = styled(Wrapper)`
  width: 30%;
  ${below.md`
    width: 90%;
  `};
`

export const NewsText = styled(Wrapper)`
  width: 60%;
  ${below.md`
    width: 90%;
  `};
`
